import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DeploymentModel, IndexAdminModel, IndexService, ModelService} from 'digiteq-ai-portal-client-lib';
import {MessageService} from 'primeng/api';
import {ErrorService} from '../../services/error.service';
import {CrudHandlerComponent} from '../../components/crud-table/crud-handler/crud-handler.component';
import {Column} from '../../models/column';
import {finalize} from 'rxjs';
import {ShowItemDialogModel} from '../../components/crud-table/crud-table.component';
import {prefillModel, prefillNewIndexValues} from 'src/app/constants/preFillNewIndexValues';

@Component({
  selector: 'app-daise-admin',
  templateUrl: './daise-admin.component.html',
  styleUrl: './daise-admin.component.scss'
})
export class DaiseAdminComponent extends CrudHandlerComponent<IndexAdminModel> implements OnInit, AfterViewInit {
  @ViewChild('roleTemplate') roleTemplate: TemplateRef<HTMLTemplateElement>;

  columns: Column[] = [];
  item?: IndexAdminModel;
  clonedItem: IndexAdminModel;
  search = '';
  models: DeploymentModel[] | undefined;

  constructor(
    messageService: MessageService,
    errorService: ErrorService,
    public indexService: IndexService
  ) {
    super (messageService, errorService);
    this.itemTypeName = 'Index';
  }

  ngOnInit(): void {
    this.indexService.getIndexesAdmin()
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (indexes) => {
          this.items = indexes;
        },
        error: err => {
          this.errorService.handleError(err, 'Could not load indexes');
        }
      });
    }

  ngAfterViewInit() {
    this.columns = [
      {field: 'name', title: 'Name'},
      {field: 'modelName', title: 'Model'},
      {field: 'roles', title: 'Roles', template: this.roleTemplate},
      {field: 'lastMessages', title: 'Last Messages'},
      {field: 'documentCount', title: 'Document Count'},
      {field: 'prompt', title: 'Prompt'},
    ];
  }

  toggle(item: IndexAdminModel) {
    if (!item.id) {
      return;
    }
    super.handleToggle(this.indexService.updateIndex(item.id, item), item, this.itemTypeName);
  }

  delete(item: IndexAdminModel) {
    if (!item.id) {
      return;
    }
    super.handleDelete(this.indexService.deleteIndex(item.id), item.id, this.itemTypeName);
  }

  onIndexDialogCancel() {
    this.showItemDialog = false;
    this.clonedItem = null;
  }

  onShowItemDialog($event: ShowItemDialogModel) {
    this.showItemDialog = $event.show;
    this.clonedItem = $event.item;
  }

  fillDefault() {
    this.clonedItem = {
      ...prefillNewIndexValues,
      deploymentId: this.models.find((model) => model.modelFriendlyName === prefillModel)?.id
    };
  }

  getDialogHeader() {
    return this.clonedItem ? `Edit ${this.itemTypeName}` : `Add ${this.itemTypeName}`;
  }

  handleAddIndex($event: IndexAdminModel) {
    this.handleAdd(this.indexService.createIndex($event), this.itemTypeName)
  }

  handleEditIndex($event: IndexAdminModel) {
    this.handleEdit(this.indexService.updateIndex($event.id, $event), this.itemTypeName)
  }
}
